import filters from "@/api/filter";
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          minWidth: 140
        },
        {
          title: '产品名称（产品编码）',
          key: 'productName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return <span>{params.row.productName}({params.row.productCode})</span>;
          },
        },
        {
          title: '承保日期',
          key: 'insureTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = filters.filterTime(params.row.insureTime,"YYYY-MM-DD")
            return (
              <span>{res}</span>
            );
          },
        },
        {
          title: '犹豫止期',
          key: 'hesitateDate',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = filters.filterTime(params.row.hesitateDate,"YYYY-MM-DD")
            return (
              <span>{res}</span>
            );
          },
        },
        {
          title: '保费（元）',
          key: 'fee',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '保单状态',
          slot: 'status',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '质检状态',
          slot: 'confirmRightStatusIn',
          minWidth: 120,
          align: 'center',
        },
        {
          title: '出单业务员',
          key: 'salesmanName',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '投/被保险人',
          key: 'insuranceName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const res = params.row.insuranceName
              ? params.row.holderName + "/" + params.row.insuranceName
              : params.row.holderName;
            return (
              <Tooltip style="width:100%" content={res}>
                <div class="txt-ellipsis2" style="display:block">
                  {res}
                </div>
              </Tooltip>
            );
          },
        },
        {
          title: '操作',
          slot: 'action',
          width: 170,
          align: 'center',
          fixed:'right',
        },
      ];
      this.columns = columns;
    }
  }
};
